import React from 'react';
import {
  CampStudyState,
  CampStudyStateOptions,
  NodeStudyState,
  NodeStudyStateLog,
} from '@/types/camp/study/index';

import {
  sourceData,
  TRewardConditionRowType,
} from '@/pages/backend/cardCampSettings/rewardSettings/rewardCondition';

interface CampStudyStateProps {
  state: number;
}
interface ConditionProps {
  condition: any;
  nodeList: any;
}

// 奖励条件转文案
export const RewardConditionToText: React.FC<ConditionProps> = ({ condition, nodeList }) => {
  let array: any = [];
  for (const field in sourceData) {
    if (condition[field]) {
      if (field === 'selectedEarnCredits' && condition.earnCredits) {
        array.push(`[${sourceData[field].label}≥${condition.earnCredits}]`);
      } else if (field === 'selectedFinishNodes' && Array.isArray(condition.finishNodes)) {
        if (Array.isArray(nodeList)) {
          // 全部选中了
          if (condition.finishNodes.length === nodeList.length) {
            array.push('[完成所有打卡节点]');
          } else {
            const nameArray = [];
            for (const node of condition.finishNodes) {
              const findItem = nodeList.find((nodeItem) => nodeItem.id === node);
              if (findItem) {
                nameArray.push(findItem.name);
              }
            }
            array.push(`[完成：${nameArray.join('、')}]`);
          }
        }
      } else if (
        field === 'selectedRank' &&
        condition.minRankAfterFinishCamp !== undefined &&
        condition.maxRankAfterFinishCamp !== undefined
      ) {
        array.push(
          `[排名${condition.minRankAfterFinishCamp}~${condition.maxRankAfterFinishCamp}名]`,
        );
      } else {
        array.push(`[${sourceData[field as TRewardConditionRowType].label}]`);
      }
    }
  }
  return array.join(' 且 ');
};

// 报名学习状态
export const CampStudyStateToText: React.FC<CampStudyStateProps> = ({ state }) => {
  const option = CampStudyStateOptions.find((option) => option.value === state);
  let className = '';
  switch (state) {
    case CampStudyState.NOT_START_LEARNING:
      className = 'col808';
      break;
    case CampStudyState.STUDYING:
      className = 'colffa';
      break;
    case CampStudyState.CAMP_FAIL:
      className = 'colff4';
      break;
    case CampStudyState.CAMP_SUCCESS:
      className = 'col52c';
      break;
    default:
      className = '';
  }

  return <span className={className}>{option?.text || '未知状态'}</span>;
};

// 节点学习状态
export const NodeStudyStateToText: React.FC<CampStudyStateProps> = ({ state }) => {
  const option = NodeStudyStateLog.find((option) => option.value === state);
  let className = '';
  switch (state) {
    case NodeStudyState.NOT_START_LEARNING:
      className = 'colc0c';
      break;
    case NodeStudyState.STUDYING:
      className = 'colffa';
      break;
    case NodeStudyState.NODE_SUCCESS:
      className = 'col52c';
      break;
    case NodeStudyState.NODE_FAIL:
      className = 'colc0c';
      break;
    default:
      className = '';
  }

  return <span className={className}>{option?.text || '未知状态'}</span>;
};
